import { TFunction } from "i18next";
import { object, string } from "yup";

export const newProjectSchema = (t: TFunction) =>
  object({
    title: string()
      .required(t("support.titleRequired"))
      .max(255, t("folder.titleLong")),
  });
